// import { getSysType } from 'CommonUtils/plus.js'

export const localset = (key, value) => { // 保存到localStorage，value可以为复杂对象
  var storage = window.localStorage
  storageSet(storage, key, value)
}
export const localget = (key) => { // 从localStorage获取值，返回值为String、或者为复杂对象
  var storage = window.localStorage
  return storageGet(storage, key)
}
export const localremove = (key) => { // 从localStorage从删除指定数据
  var storage = window.localStorage
  storageRemove(storage, key)
}
export const localclear = () => {
  var storage = window.localStorage
  storageclear(storage)
}

export const sessionset = (key, value) => { // 保存到sessionStorage，value可以为复杂对象
  var storage = window.sessionStorage
  return storageSet(storage, key, value)
}
export const sessionget = (key) => { // 从sessionStorage获取值，返回值为String、或者为复杂对象
  var storage = window.sessionStorage
  return storageGet(storage, key)
}
export const sessionremove = (key) => { // 从sessionStorage从删除指定数据
  var storage = window.sessionStorage
  storageRemove(storage, key)
}
export const sessionclear = () => { // 清楚所有保存数据
  var storage = window.sessionStorage
  storageclear(storage)
}

function storageSet (storage, key, value) {
  if (typeof (value) !== 'string') {
    value = JSON.stringify(value)
  }
  // if (getSysType() !== '10506' && storage !== window.sessionStorage) {
  // 	if (plus) {
  // 		plus.storage.setItem(key, value)
  // 	}
  // } else {
  storage.setItem(key, value)
  // }
}

function storageGet (storage, key) {
  var value
  //  ios版本 localstroage;
  // if (getSysType() !== '10506' && storage !== window.sessionStorage) {
  // 	try {
  // 		value = plus.storage.getItem(key)
  // 	} catch (e) {
  // 		value = ''
  // 	}
  // } else {
  value = storage.getItem(key)
  // }
  if (!!value && value.indexOf('{') > -1) {
    value = JSON.parse(value)
  }
  return value
}

function storageRemove (storage, key) {
  // if (getSysType() !== '10506' && storage !== window.sessionStorage) {
  // 	plus.storage.removeItem(key)
  // } else {
  storage.removeItem(key)
  // }
}

function storageclear (storage) {
  // if (getSysType() !== '10506' && storage !== window.sessionStorage) {
  // 	plus.storage.clear()
  // } else {
  storage.clear()
  // }
}
